import React, { useState } from "react"
import ItemButton from "./ItemButton"
import { useStaticQuery, graphql } from "gatsby"
import { CSSTransition, TransitionGroup } from "react-transition-group"
import { DividerLines } from "../DividerLines"

import {
  FeatureCarouselContainer,
  ListContainer,
  ListWrapper,
  List,
  TitleWrapper,
  LargeTeaser,
  ReadMoreLink,
  ExtendedTitleWrapper,
} from "./style"

const FeatureCarousel = () => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const data = useStaticQuery(
    graphql`
      query {
        allFile(
          filter: { absolutePath: { regex: "/things-to-do-images/" } }
          sort: { fields: [name], order: ASC }
        ) {
          nodes {
            id
            name
            childImageSharp {
              fluid(maxWidth: 760, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    `
  )

  const images = data.allFile.nodes

  const items = [
    {
      label: "Nature",
      excerpt:
        "Maecenas nec odio et ante tincidunt tempus. Donec elit libero, sodales nec, volutpat a, suscipit non, turpis. Maecenas ullamcorper, dui et placerat feugiat, eros pede varius nisi.",
      img: images[0],
    },
    {
      label: "Sports",
      excerpt:
        "Ondimentum viverra felis nunc et lorem. Praesent ac sem eget est egestas volutpat ondimentum viverra felis nunc et lorem. Praesent ac sem eget est egestas volutpat.",
      img: images[1],
    },
    {
      label: "Arts & Entertainment",
      excerpt:
        "Canberra is blessed with an abundance of culture and artistic expression. Our museums and galleries house living collections of national and international acclaim, as well as local works. ",
      img: images[2],
    },
    {
      label: "Multicultural Canberra",
      excerpt:
        "Maecenas ullamcorper, dui et placerat feugiat, eros pede varius nisi, condimentum viverra felis nunc et lorem. Etiam rhoncus. Mauris turpis nunc, blandit et, volutpat molestie, porta ut, ligula. Donec interdum, met.",
      img: images[3],
    },
    {
      label: "Making Friends",
      excerpt:
        "Duis vel nibh at velit scelerisque suscipit. Aliquam lobortis. Duis lobortis massa imperdiet quam. Nunc sed turpis.",
      img: images[4],
    },
    {
      label: "Eating & Drinking",
      excerpt:
        "Us et hendrerit aliquet, dolor diam sagittis ligula, eget egestas libero turpis vel mi.s et hendrerit aliquet, dolor diam sagittis ligula, eget egestas libero turpis vel mi",
      img: images[5],
    },
  ]

  return (
    <>
      <FeatureCarouselContainer>
        <ListContainer>
          <ExtendedTitleWrapper>
            <h5>Discover</h5>
            <h2>Things To Do</h2>
          </ExtendedTitleWrapper>
          <ListWrapper>
            <List>
              {items.map((item, index) => {
                return (
                  <ItemButton
                    key={index}
                    selectedIndex={selectedIndex}
                    setSelectedIndex={setSelectedIndex}
                    label={item.label}
                    index={index}
                  />
                )
              })}
            </List>
          </ListWrapper>
        </ListContainer>
        <TransitionGroup className="transitionGroup">
          <CSSTransition
            key={selectedIndex}
            in={true}
            appear={true}
            timeout={10000}
            mountOnEnter={true}
            unmountOnExit={true}
            enter={true}
            exit={true}
            classNames="fade"
          >
            <LargeTeaser
              excerpt={items[selectedIndex].excerpt}
              img={items[selectedIndex].img.childImageSharp.fluid}
              link="/"
              innerLinkText="Read more"
            />
          </CSSTransition>
        </TransitionGroup>
      </FeatureCarouselContainer>
      {/* <DividerLines margin /> */}
    </>
  )
}

export default FeatureCarousel
